/* import __COLOCATED_TEMPLATE__ from './disconnect-dialog.hbs'; */
/* RESPONSIBLE TEAM: team-data-foundations */
import type AppService from 'embercom/services/app-service';
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import type IntlService from 'embercom/services/intl';
import { action } from '@ember/object';
import { tracked } from '@glimmer/tracking';
import { taskFor } from 'ember-concurrency-ts';
import { dropTask } from 'ember-concurrency-decorators';
import { type TaskGenerator } from 'ember-concurrency';
import { post } from 'embercom/lib/ajax';

export interface Args {
  isOpen: boolean;
  onClose: () => void;
  onDisconnect: () => void;
}

interface Signature {
  Args: Args;
  Element: HTMLElement;
}

export default class Setup extends Component<Signature> {
  @service declare intl: IntlService;
  @service declare appService: AppService;
  @service declare intercomEventService: $TSFixMe;

  @tracked disconnectConfirmValue = '';

  get canDisconnect(): boolean {
    return this.disconnectConfirmValue === 'DISCONNECT';
  }

  @action async disconnect() {
    this.intercomEventService.trackAnalyticsEvent({
      action: 'clicked',
      object: 'disconnect_account',
    });
    await taskFor(this.uninstallAppPackage).perform();
    this.args.onDisconnect();
    this.args.onClose();
  }

  @dropTask *uninstallAppPackage(): TaskGenerator<void> {
    yield post('/ember/migrate_from_crm_integrations/uninstall', {
      app_id: this.appService.app.id,
      integration_code: 'migrate-from-zendesk',
    });
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'NewSettings::Data::ImportsExports::ImportZendesk::DisconnectDialog': typeof Setup;
    'new-settings/data/imports-exports/import-zendesk/disconnect-dialog': typeof Setup;
  }
}
